import { Link , NavLink} from "react-router-dom";
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
import React, {Fragment, useEffect, useRef, useState} from "react";
import LazyLoad from 'react-lazy-load';
import {Skeleton} from "@mui/material";
import { MiniSearch , MiniUp , MiniBlackLocation} from '../assets/icones/icones';
import CallIcon from '@mui/icons-material/Call';
import clientconfigwebapp, {
check_login_appbk,
convert_to_english_strhk,
empty_bk,
getLengt_bk, scrollTo_uphk,
Token_get_appbk
} from "../clientconfigwebapp";

import { W_Menu } from '../assets/icones/icones';


import './assets/css/aside.css'


const Aside = (props) => {
    const asideMenu = useRef(null);
    const asideSvg = useRef(null);

    const [data_category_box_seach_box, set_data_category_box_seach_box] = useState([]);



     const asideMenuHandler = () => {
        asideMenu.current.classList.toggle('aside_active');
        asideSvg.current.classList.toggle('aside-svg-active');
     }

    const[custom_serarch_box_title,set_custom_serarch_box_title] = useState('');

    const Handler_custom_serarch_box=(event)=>{
        set_custom_serarch_box_title(convert_to_english_strhk(event.target.value));
    }




    useEffect(() => {
        Handler_serarch_box();
    }, [custom_serarch_box_title])

    const Handler_serarch_box = () => {


        if(empty_bk(custom_serarch_box_title)==false) {
            /// if(validateResult){
            const data_form_add = {title_search:String(custom_serarch_box_title)}; //filter_search:String(filter_search)

            console.log(data_form_add,"eeeeeeeee")

            if (data_form_add != null) {


                axios.post(`${clientconfigwebapp.siteurl}api/v1/search-category`,data_form_add)
                    .then((res) => {
                        ///Setloadinghkfullshow_search("false");

                        console.log(res.data, "777777777");


                        if(String(res.data.data_category_box).length > 0) {

                            // /console.log(res.data.data, "is 657567");
                            if (res.data.status=="success"){

                                if(String(res.data.data_category_box).length > 0) {  set_data_category_box_seach_box(res.data.data_category_box); }


                            }else {
                                toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                            }


                        }else{
                          /////  Setloadinghkfullshow_search("false");
                            if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                        }

                        ///localStorage.setItem('token',response.data.Auth.access_token)
                    }).catch((err) =>{

                   ///// console.log("rrrr", "777777777");

                   //// Setloadinghkfullshow_search("false");
                    toast.error('خطای اتصال به سرور اینترنت خود را چک کنید.', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                   ///// console.error(err, "is error 4535!");

                });


               /// Setloadinghkfullshow_search("false");
            }else{
               ///// Setloadinghkfullshow_search("false");
                alert('errcode:345765');
            }

        }else{
            set_data_category_box_seach_box([]);
        }

    }


    const  menuHandler = () => {
        const menu = document.querySelector('.home-aside-container')
        menu.classList.toggle('mob-menu-act')
    }

    // const  menuHandler222 = () => {
    //
    //     props.handleClick('328455');
    // }




    const scrollToSection =(element_Getname) => {


       const element = document.getElementById(element_Getname);




        //// element.scrollIntoView({ behavior: 'smooth' });

        const yOffset = -120;

         /// y = event.target.getBoundingClientRect().top + window.pageYOffset + yOffset;
         const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});




        // html {
        //     scroll-behavior: smooth;
        // }


    };

    return (
        <Fragment>



            {   props.data_category_box.length > 0 ?  (

                <Fragment>


                    {/*onClick={ () => {   props.handleClick()  }  }*/}

                    <div className={'home-aside-container ' + String(props.costume_class)}>
                        {/*<h2 className='flexRowStartCenter'  onClick={ menuHandler222 }  >*/}
                        <h2 className='flexRowStartCenter'  >
                            <W_Menu />
                            دسته‌بندی
                        </h2>

                        <button onClick={menuHandler}>
                            <svg width='1.25rem' height='1.25rem' fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                        </button>

                        {/*<label className='w-100 flexRowBetCenter box-input-search'>*/}
                        {/*    <input autoComplete={"off"}  onChange={Handler_custom_serarch_box}  type="text" id="custom_serarch_box_title" name="custom_serarch_box_title" className="inputbox-dark-bk"  style={{"direction":"rtl"}} placeholder="جستجو..." />*/}

                        {/*    <MiniSearch />*/}
                        {/*</label>*/}


                        {  data_category_box_seach_box.length > 0 ?  (
                            <Fragment>

                                <ul className={"cat-sidebar-items aaaa"}>

                                    <li >
                                        <Link to={"/"}   className={'cat-side-bar-item'} >
                                            <span>همه دوره ها</span>
                                        </Link>
                                    </li>

                                    {data_category_box_seach_box.map((item, index) => {
                                        return (
                                            <li  key={index}>
                                                <Link to={"/course-category/" + item.id_post}   className={'cat-side-bar-item'} >
                                                    {/*className={({isActive}) => isActive ? 'flexRowStartCenter active-link' : 'flexRowStartCenter' + ' cat-side-bar-item ' }*/}
                                                    {/*<img className={"cat-icon-side-bar"} src={item.image_src} alt={item.title_post} />*/}
                                                    <span>{item.title_post}</span>
                                                </Link>
                                            </li>
                                        )
                                    })}
                                </ul>

                            </Fragment>

                        ) : (<Fragment>
                            <ul className={"cat-sidebar-items bbbb"}>

                                <li >
                                    <Link to={"/"}   className={'cat-side-bar-item'} >
                                        <span>همه دوره ها</span>
                                    </Link>
                                </li>

                                {props.data_category_box.map((item, index) => {
                                    return (
                                        <li key={index}>
                                            <Link to={"/course-category/" + item.id_post}  className={'cat-side-bar-item'} >
                                                {/*className={({ isActive }) => ( isActive ? 'aside-active' : '' ) + ' cat-side-bar-item '}*/}
                                                {/*<img  className={"cat-icon-side-bar"} src={item.image_src} alt={item.title_post} />*/}
                                                <span>{item.title_post}</span>
                                            </Link>
                                        </li>
                                    )
                                })}
                            </ul>
                        </Fragment>)   }





                    </div>




                </Fragment>

            ) : (
                <Fragment>
                    <Skeleton variant="rectangular"  style={{"width":"100%","height":"40vh","marginTop":"0px","borderRadius":"12px"}}  />
                    <Skeleton variant="rectangular"  style={{"width":"100%","height":"40vh","marginTop":"10px","borderRadius":"12px"}}  />
                </Fragment>
            )   }



        </Fragment>
    )
}
export default Aside;